module.exports = __webpack_public_path__ + "static/img/11.a7bafe1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhxnsx/11.jpg
// module id = Xxwq
// module chunks = 1